module.exports = __webpack_public_path__ + "img/default.3e62c017.png";